/* Apex Love Spell — delivery / wedding-date planner.
   Lead time comes from the product EDD Estimate metafield, with the theme
   setting used only when that product-specific value is absent. */
(() => {
  class DeliveryPlanner extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised) return;
      this.dataset.initialised = "true";

      const input = this.querySelector("[data-wedding-date]");
      const guidance = this.querySelector("[data-wedding-guidance]");
      if (!input || !guidance) return;

      const leadDays = Number(this.dataset.leadTimeDays) || 14;
      const leadTimeLabel =
        leadDays % 7 === 0
          ? `${leadDays / 7} ${leadDays === 7 ? "week" : "weeks"}`
          : `${leadDays} days`;
      guidance.textContent =
        `Current estimated production and delivery time: ${leadTimeLabel}.`;

      input.addEventListener("change", () => {
        if (!input.value) return;
        const wedding = new Date(`${input.value}T12:00:00`);
        const daysAway = Math.ceil((wedding - new Date()) / 864e5);
        const orderBy = new Date(wedding);
        orderBy.setDate(orderBy.getDate() - leadDays);
        const formatted = new Intl.DateTimeFormat(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
        }).format(orderBy);

        guidance.textContent =
          daysAway <= leadDays
            ? "Your wedding is coming up. Order now to secure your production slot."
            : `We recommend ordering by ${formatted} to allow time for production and delivery.`;

        this.track("wedding_date_guidance_viewed", {
          window: daysAway <= leadDays ? "within_lead_time" : "before_lead_time",
        });
      });
    }

    track(name, payload = {}) {
      const detail = { event: `love_spell_${name}`, ...payload };
      (window.dataLayer?.push(detail),
        window.dispatchEvent(new CustomEvent("love-spell:analytics", { detail })));
    }
  }

  customElements.get("lsp-delivery-planner") ||
    customElements.define("lsp-delivery-planner", DeliveryPlanner);
})();
